import { Button, Flex, Form, OTP, Text } from "../../components";
import { useForm } from "../../hooks";
import { useState } from "react";

const OTPVerification = ({ phone = "", onVerify = (data: any) => {} }) => {
  const [code, setCode] = useState("");

  return (
    <>
      <Text
        children={`Please, enter the code that you have received on your phone number (${phone})`}
      />
      <Flex justify="center" className="m-30-t">
        <OTP onInput={(_) => setCode(_.join(""))} length={5} value={code} />
      </Flex>
      <Button
        disabled={code.length !== 5}
        className="w-100 m-30-t"
        title="Verify"
        onClick={() => onVerify({ code })}
      />
    </>
  );
};

const Registration = ({
  styles = {},
  initialValues = {},
  onRegister = (data: any) => {},
}) => {
  const registerForm = useForm({ initialValues });

  return (
    <>
      <Form
        styles={styles}
        form={registerForm}
        fields={[
          {
            name: "alias",
            label: "Full Name",
            rule: [{ required: true }],
            placeholder: "Enter your name",
          },
          {
            name: "email",
            label: "Email (Optional)",
            rule: [{ required: true }],
            placeholder: "Enter your email",
          },
          {
            name: "gender",
            label: "Gender",
            face: "select",
            placeholder: "Select",
            rule: [{ required: true }],
            options: [
              { label: "Male", value: "male" },
              { label: "Female", value: "female" },
              { label: "Other", value: "other" },
            ],
          },
          {
            name: "dob",
            face: "datepicker",
            label: "Date of birth",
            rule: [{ required: true }],
          },
          {
            name: "phone",
            label: "Phone number",
            disabled: true,
            readOnly: true,
            placeholder: "Phone number",
            className: "opacity-60 pointer-events-none",
          },
        ]}
      />
      <Button
        className="m-30-t"
        title={!!Object.keys(initialValues).length ? "Save" : "Register"}
        onClick={async () => {
          await registerForm.validateFields();
          const { phone: _phone, ...profile } = registerForm.getFieldsValue();
          onRegister(profile);
        }}
      />
    </>
  );
};

const Auth = ({ onLogin = async (data: any) => {} }) => {
  const form = useForm();

  return (
    <div>
      <Form
        form={form}
        fields={[
          {
            name: "phone",
            label: "Phone number",
            rules: [{ required: true }],
            placeholder: "Enter your phone number",
          },
        ]}
      />
      <Button
        title="Login"
        className="w-100 m-30-t"
        onClick={async () => {
          await form.validateFields();
          await onLogin(form.getFieldsValue());
        }}
      />
      <Text className="m-20-t">
        {"By signing up, you agree to our "}
        <Text
          level={"text"}
          weight={700}
          type="base"
          className="cursor-pointer"
          children="Terms and Conditions"
        />
        {" and "}
        <Text
          level={"text"}
          weight={700}
          type="base"
          className="cursor-pointer"
          children="Privacy Policy"
        />
        {"."}
      </Text>
    </div>
  );
};

Auth.OTPVerification = OTPVerification;
Auth.Registration = Registration;
export default Auth;
